"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
var InventoryLogFilter = /** @class */ (function () {
    function InventoryLogFilter(limit, offset, filter) {
        this.setLimit(limit);
        this.setOffset(offset);
        this.setLocationId(filter.locationId);
        this.setEmployeeIds(filter.employeeIds);
        this.setProductIds(filter.productIds);
        this.setType(filter.type);
        this.setInvoiceId(filter.invoiceId);
        this.setTransferId(filter.transferId);
        this.setPaymentId(filter.paymentId);
        this.setStartDate(filter.startDate);
        this.setEndDate(filter.endDate);
        this.setCategoryIds(filter.categoryIds);
        this.setNotesQuery(filter.notesQuery);
        this.setModified(filter.modified);
    }
    InventoryLogFilter.prototype.setLimit = function (limit) { this.limit = limit; };
    InventoryLogFilter.prototype.setOffset = function (offset) { this.offset = offset; };
    InventoryLogFilter.prototype.setLocationId = function (locationId) { this.locationId = locationId; };
    InventoryLogFilter.prototype.setEmployeeIds = function (employeeIds) { this.employeeIds = employeeIds; };
    InventoryLogFilter.prototype.setCategoryIds = function (categoryIds) { this.categoryIds = categoryIds; };
    InventoryLogFilter.prototype.setProductIds = function (productIds) { this.productIds = productIds; };
    InventoryLogFilter.prototype.setType = function (type) { this.type = type; };
    InventoryLogFilter.prototype.setNotesQuery = function (notesQuery) { this.notesQuery = notesQuery; };
    InventoryLogFilter.prototype.setInvoiceId = function (invoiceId) { this.invoiceId = invoiceId; };
    InventoryLogFilter.prototype.setTransferId = function (transferId) { this.transferId = transferId; };
    InventoryLogFilter.prototype.setPaymentId = function (paymentId) { this.paymentId = paymentId; };
    InventoryLogFilter.prototype.setStartDate = function (startDate) { this.startDate = startDate; };
    InventoryLogFilter.prototype.setEndDate = function (endDate) { this.endDate = endDate; };
    InventoryLogFilter.prototype.setModified = function (modified) { this.modified = modified; };
    Object.defineProperty(InventoryLogFilter.prototype, "queryString", {
        get: function () {
            var queryString = '';
            if (this.limit) {
                queryString += "&limit=" + this.limit;
            }
            if (this.offset) {
                queryString += "&offset=" + this.offset;
            }
            if (this.locationId) {
                queryString += "&locationId=" + this.locationId;
            }
            if (this.employeeIds && (this.employeeIds.length > 0)) {
                queryString += "&employeeIds=" + JSON.stringify(this.employeeIds);
            }
            if (this.categoryIds && (this.categoryIds.length > 0)) {
                queryString += "&categoryIds=" + JSON.stringify(this.categoryIds);
            }
            if (this.productIds && (this.productIds.length > 0)) {
                queryString += "&productIds=" + JSON.stringify(this.productIds);
            }
            if (this.type) {
                queryString += "&type=" + this.type;
            }
            if (this.notesQuery) {
                queryString += "&notesQuery=" + this.notesQuery;
            }
            if (this.invoiceId) {
                queryString += "&invoiceId=" + this.invoiceId;
            }
            if (this.transferId) {
                queryString += "&transferId=" + this.transferId;
            }
            if (this.paymentId) {
                queryString += "&paymentId=" + this.paymentId;
            }
            if (this.startDate) {
                queryString += "&startDate=" + this.startDate.startOf('day').toDate().toISOString();
            }
            if (this.endDate) {
                queryString += "&endDate=" + this.endDate.endOf('day').toDate().toISOString();
            }
            if (!lodash_1.isNil(this.modified)) {
                queryString += "&modified=" + this.modified;
            }
            return queryString;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "limit", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "offset", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "locationId", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "employeeIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "productIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "type", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "invoiceId", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "transferId", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "paymentId", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "startDate", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "endDate", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "categoryIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "notesQuery", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryLogFilter.prototype, "modified", void 0);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setLimit", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setOffset", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setLocationId", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setEmployeeIds", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setCategoryIds", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setProductIds", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setType", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setNotesQuery", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setInvoiceId", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setTransferId", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setPaymentId", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setStartDate", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setEndDate", null);
    __decorate([
        mobx_1.action
    ], InventoryLogFilter.prototype, "setModified", null);
    return InventoryLogFilter;
}());
exports.InventoryLogFilter = InventoryLogFilter;
var InventoryLogSubtypeForDB;
(function (InventoryLogSubtypeForDB) {
    InventoryLogSubtypeForDB["PHYSICAL_INV_COUNT_OPERATIONAL"] = "phInvCoOper";
    InventoryLogSubtypeForDB["PHYSICAL_INV_COUNT_AGCO"] = "phInvCoAGCO";
    InventoryLogSubtypeForDB["DATA_ENTRY_ERROR"] = "dataEntryErr";
    InventoryLogSubtypeForDB["SOLD_PRODUCT_HANDLING_ERROR"] = "soldProdHandErr";
    InventoryLogSubtypeForDB["RECEIVING_ERROR"] = "receivingErr";
    InventoryLogSubtypeForDB["CYCLE_COUNT"] = "cycleCo";
    InventoryLogSubtypeForDB["INTERNAL_AUDIT"] = "intAudit";
})(InventoryLogSubtypeForDB = exports.InventoryLogSubtypeForDB || (exports.InventoryLogSubtypeForDB = {}));
var InventoryLogSubtypeForBlaze;
(function (InventoryLogSubtypeForBlaze) {
    InventoryLogSubtypeForBlaze["PHYSICAL_INV_COUNT_OPERATIONAL"] = "Physical Inventory Count (Operationally Initiated)";
    InventoryLogSubtypeForBlaze["PHYSICAL_INV_COUNT_AGCO"] = "Physical Inventory Count (AGCO Initiated)";
    InventoryLogSubtypeForBlaze["DATA_ENTRY_ERROR"] = "Data Entry Error";
    InventoryLogSubtypeForBlaze["SOLD_PRODUCT_HANDLING_ERROR"] = "Sold Product Handling Error";
    InventoryLogSubtypeForBlaze["RECEIVING_ERROR"] = "Receiving Error";
    InventoryLogSubtypeForBlaze["CYCLE_COUNT"] = "Cycle Count";
    InventoryLogSubtypeForBlaze["INTERNAL_AUDIT"] = "Internal Audit";
})(InventoryLogSubtypeForBlaze = exports.InventoryLogSubtypeForBlaze || (exports.InventoryLogSubtypeForBlaze = {}));
var InventoryLogSubtypeForOCS;
(function (InventoryLogSubtypeForOCS) {
    InventoryLogSubtypeForOCS["PHYSICAL_INV_COUNT_OPERATIONAL"] = "Physical Inventory Count (Operationally Initiated)";
    InventoryLogSubtypeForOCS["PHYSICAL_INV_COUNT_AGCO"] = "Physical Inventory Count (AGCO Initiated)";
    InventoryLogSubtypeForOCS["DATA_ENTRY_ERROR"] = "Data Entry Error";
    InventoryLogSubtypeForOCS["SOLD_PRODUCT_HANDLING_ERROR"] = "Sold Product Handling Error";
    InventoryLogSubtypeForOCS["RECEIVING_ERROR"] = "Receiving Error";
    InventoryLogSubtypeForOCS["CYCLE_COUNT"] = "Cycle Count";
    InventoryLogSubtypeForOCS["INTERNAL_AUDIT"] = "Internal Audit";
})(InventoryLogSubtypeForOCS = exports.InventoryLogSubtypeForOCS || (exports.InventoryLogSubtypeForOCS = {}));
exports.inventoryLogSubtypes = {
    phInvCoOper: {
        dbVal: InventoryLogSubtypeForDB.PHYSICAL_INV_COUNT_OPERATIONAL,
        blazeVal: InventoryLogSubtypeForBlaze.PHYSICAL_INV_COUNT_OPERATIONAL,
        ocsVal: InventoryLogSubtypeForOCS.PHYSICAL_INV_COUNT_OPERATIONAL,
    },
    phInvCoAGCO: {
        dbVal: InventoryLogSubtypeForDB.PHYSICAL_INV_COUNT_AGCO,
        blazeVal: InventoryLogSubtypeForBlaze.PHYSICAL_INV_COUNT_AGCO,
        ocsVal: InventoryLogSubtypeForOCS.PHYSICAL_INV_COUNT_AGCO,
    },
    dataEntryErr: {
        dbVal: InventoryLogSubtypeForDB.DATA_ENTRY_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.DATA_ENTRY_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.DATA_ENTRY_ERROR,
    },
    soldProdHandErr: {
        dbVal: InventoryLogSubtypeForDB.SOLD_PRODUCT_HANDLING_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.SOLD_PRODUCT_HANDLING_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.SOLD_PRODUCT_HANDLING_ERROR,
    },
    receivingErr: {
        dbVal: InventoryLogSubtypeForDB.RECEIVING_ERROR,
        blazeVal: InventoryLogSubtypeForBlaze.RECEIVING_ERROR,
        ocsVal: InventoryLogSubtypeForOCS.RECEIVING_ERROR,
    },
    cycleCo: {
        dbVal: InventoryLogSubtypeForDB.CYCLE_COUNT,
        blazeVal: InventoryLogSubtypeForBlaze.CYCLE_COUNT,
        ocsVal: InventoryLogSubtypeForOCS.CYCLE_COUNT,
    },
    intAudit: {
        dbVal: InventoryLogSubtypeForDB.INTERNAL_AUDIT,
        blazeVal: InventoryLogSubtypeForBlaze.INTERNAL_AUDIT,
        ocsVal: InventoryLogSubtypeForOCS.INTERNAL_AUDIT,
    },
};
//# sourceMappingURL=Logs.js.map